export default __webpack_public_path__ + "static/media/check-blue.4116c339.svg";